import { EgyptianRoom, Passage, Room } from '..';
import { Direction } from '../../../parse';
import { EntitySpec } from '../../game';
import { DeepRavine } from '../DeepRavine';
import { DomeRoom } from '../DomeRoom';
import { Player } from '../../actors';
import { Coffin } from '../../items';

export class RockyCrawl extends Room {
    static spec(): EntitySpec<RockyCrawl> {
        return {
            ref: 'rocky-crawl',
            constructor: RockyCrawl,
            initial: {
                contents: [],
                hasBeenVisited: false,
                hasBeenDescribed: false,
            },
            nouns: [],
            adjectives: [],
            handlers: [],
        };
    }

    ref() {
        return RockyCrawl.spec().ref;
    }

    name(): string {
        return 'Rocky Crawl';
    }

    description(): string {
        return (
            'This is a crawlway with a three-foot high ceiling. ' +
            'Your footing is very unsure here due to the assortment of rocks underfoot. ' +
            'Passages can be seen in the east, west, and northwest corners of the passage.'
        );
    }

    isNaturallyLit(): boolean {
        return false;
    }

    passages(): Passage[] {
        return [
            new Passage({
                via: Direction.West,
                to: DeepRavine.spec().ref,
            }),
            new Passage({
                via: Direction.Northwest,
                to: EgyptianRoom.spec().ref,
                condition: () =>
                    !this.game.ent(Player).hasItem(this.game.ent(Coffin)),
                message: 'The passage is too narrow to accommodate coffins.',
            }),
            new Passage({ via: Direction.East, to: DomeRoom.spec().ref }),
        ];
    }
}
